import { Injectable } from '@angular/core';
import { Observable, of, NEVER, timer } from 'rxjs';
import { expand, skip } from 'rxjs/operators';
import { TimeagoClock } from 'ngx-timeago';

@Injectable({
  providedIn: 'root',
})
export class CustomClock extends TimeagoClock {
  private minute = 60;
  private hour = this.minute * 60;
  private day = this.hour * 24;

  tick(then: number): Observable<number> {
    return of(0).pipe(
      expand(() => {
        const now = Date.now();
        const seconds = Math.round(Math.abs(now - then) / 1000);

        const period = seconds < this.minute ? 10000 : seconds < this.hour ? 1000 * this.minute : seconds < this.day ? 1000 * this.hour : 0;

        return period ? timer(period) : NEVER;
      }),
      skip(1)
    );
  }
}
